$(document).ready(function(){

	if ($('canvas.chart--pie').length) {

		// -- custom tooltip --
		Chart.defaults.global.tooltips.custom = function(tooltip) {
	
		  // Tooltip Element
		  var $this = this;
		  var tooltipEl = $('.chart__tooltip');
		  
		  $(tooltipEl).each(function(key, value) {
		  	if ($(value).prev()[0] == $this._chart.canvas) {

		  		// Hide if no tooltip
		  		if (tooltip.opacity === 0) {
		  		  $(value).animate({
		  		    'opacity': 0
		  		  },300);
		  		  return;
		  		}

		  		// Set caret Position
		  		$(value).removeClass('above', 'below', 'no-transform');
		  		if (tooltip.yAlign) {
		  		  $(value).addClass(tooltip.yAlign);
		  		} else {
		  		  $(value).addClass('no-transform');
		  		}

		  		function getBody(bodyItem) {
		  		  return bodyItem.lines;
		  		}

		  		// Set Text
		  		if (tooltip.body) {
		  		  var bodyLines = tooltip.body.map(getBody);

		  		  bodyLines.forEach(function(body, i) {
		  		    var colors = tooltip.labelColors[i];
		  		    var style = 'background:' + colors.backgroundColor;
		  		    var span = '<span class="chart__tooltip__key" style="' + style + '"></span>';
		  		    var body = '<span class="chart__tooltip__body">' + body + '%</span>';
		  		     $(value).html(span + body);
		  		  });
		  		}

		  		var positionY = $this._chart.canvas.offsetTop;
		  		var positionX = $this._chart.canvas.offsetLeft;

		  		// Display, position, and set styles for font
		  		$(value).animate({    
		  		  'opacity' : 1,
		  		  'left' : positionX + tooltip.caretX + 'px',
		  		  'top' : positionY + tooltip.caretY + 'px',
		  		},300);

		  	}
		  });

		};

	}


		// -- init chart pie --
	if ($('canvas.chart--pie').length) {

		var ctx = $('canvas.chart--pie');
		
		$(ctx).each(function(key, value) {

			var id = ($(value).attr('id')).split('-')[1];
			var config = {
			  type: 'pie',
			  data: window['data'+id],
			  options: {
			    responsive: true,
			    legend: false,
			    legendCallback: function(chart) {
		        var legendHtml = [];
		        var item = chart.data.datasets[0];
		        for (var i=0; i < item.data.length; i++) {
	            legendHtml.push('<li>');
	            legendHtml.push('<span class="icon" style="background-color:' + item.backgroundColor[i] +'"></span>');
	            legendHtml.push('<span class="text">' + chart.data.labels[i] + ' <strong>' + item.data[i] + '%</strong></span>');
	            legendHtml.push('</li>');
		        }
		        return legendHtml.join("");
			    },
			    tooltips: {
		        // Disable the on-canvas tooltip
		        enabled: false,
	        }
			  }
			};
			var myChart = new Chart($(value), config);
			$(value).parents('.chart__wrapper').find('.chart__legend').html(myChart.generateLegend());
  
		});

	}




		// -- init chart bar --

	if ($('canvas.chart--bar').length) {

		var ctx_bar = $('canvas.chart--bar');
		
		$(ctx_bar).each(function(key, value) {

			var id = ($(value).attr('id')).split('-')[1];
			var config = {
			  type: 'bar',
			  data: window['data_bar_'+id],
			  options: {
			    responsive: true,
			    legend: false,
			    tooltips: {
			    	callbacks: {
			    		label: function(tooltipItem, data) {
			    			return tooltipItem.yLabel + ' Millions EUR';
			    		}
			    	}
			    },
			    scales: {
			    	yAxes: [{
			    		ticks: {
			    			min: 0,
	              callback: function(value, index, values) {
	              	return value + ' M';
	              }
	            }
	          }]
	        }
			  }
			};
			var myChart = new Chart($(value), config);
	 
		});
	}

	
});